import { createAsyncThunk } from '@reduxjs/toolkit';
import { ImageModel, ImageModelSchema } from 'shared';
// eslint-disable-next-line no-restricted-imports
import { ApiFactory, ApiResponse } from 'shared/api';
import BaseError from 'utils/base-error';
import { z } from 'zod';

/**
 * Инстанс апишки
 */
const apiInstance = ApiFactory.getInstance();

/**
 * Схема для парсинга респонса
 */
export const GetOutdoorBarsServiceApiResponseSchema = z.object({
    data: z.object({
        documentId: z.string(),
        title: z.string(),
        description: z.any().optional().nullable(),
        image: z.object({
            url: z.string(),
        }).optional().nullable(),
    }),
});

type GetOutdoorBarsServiceApiResponse
    = ApiResponse<z.infer<typeof GetOutdoorBarsServiceApiResponseSchema>>;

type GetOutdoorBarsServiceActionRequest = undefined

export const getOutdoorBarsService = createAsyncThunk<
    GetOutdoorBarsServiceApiResponse | BaseError,
    GetOutdoorBarsServiceActionRequest
>(
    'OutdoorBarsPageActionsGetOutdoorBarsService',
    async () => apiInstance.get(
        '/outdoor-bars-service',
        {
            'populate[image][fields]': 'url',
        },
        GetOutdoorBarsServiceApiResponseSchema,
    ),
);

export const GetOutdoorBarsServiceActionResponseMapper = {
    getImage: (
        { data }: GetOutdoorBarsServiceApiResponse,
    ): ImageModel => ImageModelSchema.parse({
        url: data.data.image?.url,
    }),

    getTitle: (
        { data }: GetOutdoorBarsServiceApiResponse,
    ): string => data.data.title,

    getDescription: (
        { data }: GetOutdoorBarsServiceApiResponse,
    ): any => data.data.description,
};
